// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1uSMD","select":"Header_select__3qtl2","clinic":"Header_clinic__1IUo8"};